<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="
            $router
              .push({
                name: baseUrl,
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          Liste des questions
        </button>
        <NewQuestionButton class="ml-4" :currentChecklist="currentChecklist" />
        <button
          type="button"
          class="btn btn-custom-primary ml-4"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: baseUrl + '-show',
                params: {
                  id: currentChecklist.id,
                  questionUuid: questionUuid,
                  type: getQuestionTypeCodeUrl(form.questionable_type),
                },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-eye"></i> Aperçu
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Modification d'une question a réponse numérique (QRN)
            </h4>
            <p class="card-title-desc">
              Une question a réponse numérique doit être répondue par une valeur
              numérique
            </p>
            <div class="row d-flex justify-content-lg-center">
              <div class="col-md-12 col-lg-4">
                <div class="form-group">
                  <label for="libelle"
                    >Libellé de la question
                    <span class="text-danger">*</span></label
                  >
                  <textarea
                    v-model="form.libelle"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('libelle'),
                    }"
                    rows="3"
                    maxlength="200"
                    placeholder="Libellé de la question"
                    required
                  ></textarea>
                  <has-error :form="form" field="libelle"></has-error>
                </div>
              </div>
              <div class="col-md-6 col-lg-2">
                <div class="form-group">
                  <label for="ordre">Ordre </label>
                  <div class="input-group">
                    <div
                      class="input-group-prepend bg-transparent"
                      @click="form.ordre = form.ordre--"
                    >
                      <span
                        class="input-group-text bg-transprent border-right-0"
                        role="button"
                      >
                        <i class="fa fa-minus text-danger"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control text-center"
                      :class="{
                        'is-invalid': form.errors.has('ordre'),
                      }"
                      id="ordre"
                      v-model.number="form.ordre"
                      placeholder="Ordre"
                      required
                    />
                    <div
                      class="input-group-append bg-transparent"
                      @click="form.ordre++"
                    >
                      <span
                        class="input-group-text bg-transprent border-left-0"
                        role="button"
                      >
                        <i class="fa fa-plus text-success"></i>
                      </span>
                    </div>
                  </div>
                  <has-error :form="form" field="ordre"></has-error>
                </div>
              </div>
              <div class="col-md-6 col-lg-2">
                <div class="form-group">
                  <label for="valeur_min"
                    >Valeur minimum <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('valeur_min') }"
                    id="valeur_min"
                    v-model.number="form.valeur_min"
                    type="text"
                    placeholder="Valeur minimum"
                    required
                  />
                  <has-error :form="form" field="valeur_min"></has-error>
                </div>
              </div>
              <div class="col-md-6 col-lg-2">
                <div class="form-group">
                  <label for="valeur_max"
                    >Valeur maximum <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('valeur_max') }"
                    id="valeur_max"
                    v-model.number="form.valeur_max"
                    type="text"
                    placeholder="Valeur maximum"
                    required
                  />
                  <has-error :form="form" field="valeur_max"></has-error>
                </div>
              </div>
              <div class="col-md-6 col-lg-1 mt-3 pt-1">
                <switches
                  text-enabled="Statut actif"
                  text-disabled="Statut inactif"
                  v-model="form.statut"
                  type-bold="true"
                  color="custom-primary"
                  class="ml-1 mb-0 font-size-17"
                ></switches>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/checklist-question';
import NewQuestionButton from '../NewQuestionButton.vue';
import Form from 'vform';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new Form({
        libelle: '',
        ordre: 0,
        valeur_min: 0,
        valeur_max: '',
        statut: false,
      }),
      currentQuestion: null,
    };
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
    baseUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  components: {
    NewQuestionButton,
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.questionUuid = this.$route.params.questionUuid;

      window.axios
        .get(URL.QN + '/' + this.questionUuid, {
          params: {
            edit: true,
          },
        })
        .then((resp) => {
          Object.assign(this.form, resp.data.question);
        })
        .catch();
    },
    submit() {
      this.form
        .put(URL.QN + '/' + this.questionUuid)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}
</style>
